import React from 'react'
import { Controller } from 'react-hook-form'
import cx from 'classnames'
import * as R from 'ramda'

import styles from './Radio.module.scss'

export const Radio = React.forwardRef(
  (
    {
      error,
      fieldClassName,
      id,
      name,
      placeholder,
      value,
      onBlur,
      onChange,
      isDisabled = false,
      isRequired = false,
    },
    ref,
  ) => {
    return (
      <input
        className={cx(styles.radio, {
          [fieldClassName]: Boolean(fieldClassName),
          [styles.invalid]: Boolean(error),
        })}
        type="radio"
        checked={value}
        disabled={isDisabled}
        required={isRequired}
        {...{ id, name, placeholder, ref, onBlur, onChange }}
      />
    )
  },
)

export const ControlledRadio = ({
  control,
  error,
  fieldClassName,
  id,
  name,
  isDisabled,
  isRequired,
}) => (
  <Controller
    render={({ field: { name, ref, value, onBlur, onChange } }) => (
      <Radio
        {...{
          error,
          fieldClassName,
          id,
          name,
          ref,
          value,
          onBlur,
          onChange,
          isDisabled,
          isRequired,
        }}
      />
    )}
    {...{ control, name }}
  />
)
